module.exports = __webpack_public_path__ + "static/media/AK47.df62539a.png";